import {useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {useAppToast} from "@ui-seeker/app";
import {postSubmit, isEmpty, scrollToComponent, formatDate, FORMAT_DATE_BACK, stringToDate} from "@ui-seeker/utils";

import { WEBBACK_V2_API } from "@constants";
import { commonFiltersValue } from "@signals";
import { shareOfSearchKpiEvolutionFilters, shareOfSearchKpiEvolutionKeywordsOptions } from "../../@signals";


export default function useShareOfSearchKPIEvolutionData() {
	const { showToast } = useAppToast()

	const dataEvolutionKeys = useSignal([])
    const dataEvolution = useSignal([])
	const keywordID = useSignal("")
	const textInfo = useSignal("")
	const isLoadingDataEvolution = useSignal(false)
    const dateRange = useSignal([])


    useEffect(() => {
        
		if (!isEmpty(shareOfSearchKpiEvolutionFilters.value)) batch(() => {
			isLoadingDataEvolution.value = true
            dataEvolution.value = {}

			if ('keyword' in shareOfSearchKpiEvolutionFilters.value)
				keywordID.value = shareOfSearchKpiEvolutionFilters.value['keyword'][0]

			showToast.promise(postSubmit(`${WEBBACK_V2_API}/share-of-search/kpi/evolution`, {
				...commonFiltersValue.peek(),
				...shareOfSearchKpiEvolutionFilters.value,
			}).then(res => batch(() => {
                dataEvolution.value = res.chartData
				dataEvolutionKeys.value = res.chartKeys
				textInfo.value = res.chartTextInfo
                dateRange.value = [stringToDate(shareOfSearchKpiEvolutionFilters.value.startDate), stringToDate(shareOfSearchKpiEvolutionFilters.value.endDate)]
                isLoadingDataEvolution.value = false
			})).catch(() => showToast.error()
            ).finally(() => scrollToComponent('evolution-chart')))
		}) 

		if (isEmpty(shareOfSearchKpiEvolutionFilters.value)) batch( () => {
			dataEvolution.value = {}
		    dataEvolutionKeys.value = {}
		})

	}, [JSON.stringify(shareOfSearchKpiEvolutionFilters.value)]);

    const onChange = (e) => {
        batch(() => {
            dateRange.value = e
            shareOfSearchKpiEvolutionFilters.value = {
                ...shareOfSearchKpiEvolutionFilters.value,
                startDate: formatDate(e[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(e[1], { format: FORMAT_DATE_BACK }),
            }
        })
    }

    const resetEvolutionData = () => batch(() => {
		dataEvolution.value = {}
		dataEvolutionKeys.value = {}
		keywordID.value = ""
		shareOfSearchKpiEvolutionFilters.value = {}
		shareOfSearchKpiEvolutionKeywordsOptions.value = {}
		textInfo.value = ""
		scrollToComponent('table-details')
	})

	return {
		dataEvolution: dataEvolution.value,
		isLoadingDataEvolution: isLoadingDataEvolution.value,
		dataEvolutionKeys: dataEvolutionKeys.value,
		keywordID: keywordID,
		textInfo: textInfo.value,
        dateRange: dateRange.value,

        onChange,
        resetEvolutionData
	}
}